import type { FaireProductEntity } from "../../entity_types/product";

export const p_s6vhzuwv9f: FaireProductEntity = {
  token: "p_s6vhzuwv9f",
  type: "product",
  name: "Tomato Catch-all Tray",
  brandToken: "b_btb379emrh",
  brandName: "Mel Andrel",
  imageUrl: "https://cdn.faire.com/fastly/8269a07f75289598b1ceec15f56a85af69fe8b32333a168502ffb50bddfad151.png",
  galleryImageUrls: [],
  priceDollars: 8,
  description: "A vibrant metal tray perfect for trinkets, snacks, and more!\n\nA catchall for your desk and a perfect way to proudly display your tomato sticky notes and stationery. \n\nGood to know:\n-Measures 7\"x5.5\"\n-Durable metal tray\n",
  tags: [],
  msrpDollars: 16,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-06T18:33:10.040Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
